module.exports = __webpack_public_path__ + "fwm_h5/img/JiukemuLogo.b0d92e15.png";